import template from './TagsContainerView.html';
import { TagsContainerController } from './TagsContainerController';
export const TagsContainerComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: TagsContainerController,
    controllerAs: '$ctrl',
    template: template,
    bindings: {
        data: '<',
        application: '<',
        queue: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        onChange: '&?',
        elementId: '@?',
    },
};
